var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Box } from 'shared/components';
import { usePowerPanelContext } from '../contexts';
export var PowerPanelFooter = function () {
    var footer = usePowerPanelContext().footer;
    if (footer === null)
        return _jsx(_Fragment, {});
    return (_jsx(Box, __assign({ px: 4, py: 3, flexShrink: 0, pos: "sticky", bottom: 0, background: "white", boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.15)' }, { children: footer })));
};
